// extracted by mini-css-extract-plugin
module.exports = {"addedProductContainer":"addedProductOrDemand_addedProductContainer__2IUL4","buttonSuccessStyle":"addedProductOrDemand_buttonSuccessStyle__2hKyL"};